"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StopColorElement = exports.StartColorElement = exports.SpinnerBox = exports.PositionContainer = exports.Message = exports.LoaderContainer = exports.LoaderBox = exports.CircleWrapper = exports.CircleFill = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LoaderContainer = exports.LoaderContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__LoaderContainer",
  componentId: "sc-1plf1zs-0"
})(["z-index:100;width:100%;height:100%;", ";"], ({
  internal
}) => internal ? (0, _styledComponents.css)(["position:absolute;height:calc(100% - 40px);"]) : (0, _styledComponents.css)(["position:fixed;top:0;left:0;background-color:", ";"], ({
  theme
}) => theme.colors.loadingIndicator.externalBg));
const PositionContainer = exports.PositionContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__PositionContainer",
  componentId: "sc-1plf1zs-1"
})(["position:absolute;z-index:100;top:50%;left:50%;width:90px;height:90px;transform:translate(-50%,-50%) scale(1,-1);"]);
const rotateLoadAnimation = (0, _styledComponents.keyframes)(["0%{transform:rotate(360deg);}100%{transform:rotate(0deg);}"]);
const rotateCircle = (0, _styledComponents.keyframes)(["0%{transform:rotate(-360deg);}100%{transform:rotate(0deg);}"]);
const CircleWrapper = exports.CircleWrapper = _styledComponents.default.svg.withConfig({
  displayName: "styles__CircleWrapper",
  componentId: "sc-1plf1zs-2"
})(["stroke:", ";transform:rotate(-90deg);animation:", " 1s infinite linear;"], ({
  theme
}) => theme.colors.loadingIndicator.circleBg, rotateCircle);
const CircleFill = exports.CircleFill = _styledComponents.default.circle.withConfig({
  displayName: "styles__CircleFill",
  componentId: "sc-1plf1zs-3"
})(["stroke-dashoffset:136.659;stroke:", ";"], ({
  theme
}) => theme.colors.loadingIndicator.bg);
const LoaderBox = exports.LoaderBox = _styledComponents.default.svg.withConfig({
  displayName: "styles__LoaderBox",
  componentId: "sc-1plf1zs-4"
})(["position:relative;width:100%;height:100%;border-radius:50%;animation:", " 1s infinite linear;"], rotateLoadAnimation);
const StartColorElement = exports.StartColorElement = _styledComponents.default.stop.withConfig({
  displayName: "styles__StartColorElement",
  componentId: "sc-1plf1zs-5"
})(["stop-color:", ";"], ({
  theme
}) => theme.colors.loadingIndicator.startColor);
const StopColorElement = exports.StopColorElement = _styledComponents.default.stop.withConfig({
  displayName: "styles__StopColorElement",
  componentId: "sc-1plf1zs-6"
})(["stop-color:", ";"], ({
  theme
}) => theme.colors.loadingIndicator.stopColor);
const SpinnerBox = exports.SpinnerBox = _styledComponents.default.div.withConfig({
  displayName: "styles__SpinnerBox",
  componentId: "sc-1plf1zs-7"
})(["display:flex;align-items:center;position:absolute;top:0;left:0;bottom:0;right:0;background:", ";z-index:100;justify-content:center;flex-direction:column;svg{& rect{fill:", ";}}"], ({
  theme
}) => theme.colors.loadingIndicator.overlayBg, ({
  theme
}) => theme.colors.loadingIndicator.bg);
const Message = exports.Message = _styledComponents.default.p.withConfig({
  displayName: "styles__Message",
  componentId: "sc-1plf1zs-8"
})(["text-align:center;max-width:50%;margin-top:20px;"]);